import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App/App.jsx';
import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './hoc/ScrollToTop';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import burgerBuilderReducer from './store/reducers/burgerBuilderReducer';
import ordersReducer from './store/reducers/ordersReducer';
import globalReducer from './store/reducers/globalReducer';
import authReducer from './store/reducers/authReducer';
import PageChangeHandler from './hoc/PageChangeHandler/PageChangeHandler';

const rootReducer = combineReducers({
  burger: burgerBuilderReducer,
  orders: ordersReducer,
  auth: authReducer,
  global: globalReducer
});
const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || null : compose;
const store = createStore(rootReducer, composeEnhancers(
  applyMiddleware(thunk)
));

const app = (<Provider store={store}><BrowserRouter>
  <ScrollToTop>
    <PageChangeHandler>
      <App />
    </PageChangeHandler>
  </ScrollToTop>
</BrowserRouter>
</Provider>
)



ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js